import { ProlongationKaskoData } from '../contracts/Prolongation'

type State = Partial<ProlongationKaskoData>

export default {
  namespaced: true,
  state: (): State => {
    return {
      submissionId: null,
      startDate: null,
      endDate: null,
      markName: null,
      modelName: null,
      yearIssue: null,
      email: null,
      licensePlate: null,
      paymentSumRub: null,
      insurancePremiumFall: null,
      documents: [],
    }
  },
  getters: {
    GET_PROLONGATION_KASKO_DATA(state: State): State {
      return state
    },
    GET_SUBMISSION_ID(state: State): string {
      return state.submissionId
    },
    GET_EMAIL(state: State): string {
      return state.email
    },
    GET_DOCUMENTS(state: State): ProlongationKaskoData['documents'] {
      return state.documents
    },
  },
  mutations: {
    SET_PROLONGATION_KASKO_DATA(state: State, data: State) {
      for (const key in state) {
        if (key in data) {
          state[key] = data[key]
        }
      }
    },
    SET_SUBMISSION_ID(state: State, payload: string): string {
      state.submissionId = payload
    },
    SET_EMAIL(state: State, email: string) {
      state.email = email
    },
    SET_DOCUMENTS(state: State, documents: ProlongationKaskoData['documents']) {
      state.documents = [...documents]
    },
  },
}
